import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Busyable } from 'src/app/shared/editors/busyable';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { OrganizationsService } from 'src/app/Services/organizations.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-parkingpermit',
    templateUrl: './parkingpermit.component.html',
    styleUrls: ['./parkingpermit.component.scss'],
    standalone: false
})
export class ParkingPermitComponent extends Busyable implements OnInit {
  public ModelId: any;
  public Filters: any;
  public Model: any;
  public orgService: OrganizationsService;
  public imageHeight: number = 0;
  public router: Router;
  public san !: DomSanitizer;

  constructor(private apiService: ApiServiceBase, private parentRoute: ActivatedRoute, organizationService: OrganizationsService, router: Router, private sanitizer: DomSanitizer) {
    super();
    this.orgService = organizationService;
    this.router = router;
    this.san = sanitizer;
  }

  ngOnInit(): void {
    this.Loading();
    this.parentRoute.params.subscribe(params => { this.ModelId = params['id']; });
    this.apiService.Get<any>("permits/" + this.ModelId).then(result => {
      this.Model = result;
      this.StopLoading();
    });
  }

  public isSingleUserPermit(): boolean {
    return this.Model?.ClassName === 'SingleUserParkingPermit';
  }

  public isMultiUserPermit(): boolean {
    return this.Model?.ClassName === 'MultiUserParkingPermit';
  }

  public Columns : Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Used On", "UsedOnLocalFriendlyString"),
    new Datalistviewcolumn("Applied By", "AppliedByUserName"),
    new Datalistviewcolumn("Confirmed By", "ConfirmedByUsers"),
    new Datalistviewcolumn("Rejected By", "RejectedByUsers"),
    new Datalistviewcolumn("Session ID", "ParkingSessionId")
  ];

  public CustomAction(item: any){
    this.router.navigate(["/parking/parking/sessions/" + item.ParkingSessionId]);
  }

  public SuspendPermit(){
    this.Loading();
    this.apiService.Post<any>("permits/" + this.ModelId + '/suspended', {}).then(result => {
      this.Model = result;
      this.StopLoading();
    });
  }

  public UnsuspendPermit(){
    this.Loading();
    this.apiService.Delete<any>("permits/" + this.ModelId + '/suspended', {}).then(result => {
      this.Model = result;
      this.StopLoading();
    });
  }

}
